'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductItem = function () {
  function ProductItem(el) {
    (0, _classCallCheck3.default)(this, ProductItem);

    this.el = el;
    this.ev = new _EventHandler2.default();

    this.productColors = this.el.querySelector('[data-product-colors]');
    this.colorLabel = this.el.querySelector('h4.color');
    this.titleLabel = this.el.querySelector('h2.title a');
    this.priceLabel = this.el.querySelector('p.price .money.price-min');
    this.priceMaxLabel = this.el.querySelector('p.price .money.price-max');
    this.priceCompareLabel = this.el.querySelector('p.price .money.original');
    this.productImage = this.el.querySelector('.product-card-figure');

    this.initProductColors();
  }

  (0, _createClass3.default)(ProductItem, [{
    key: 'initProductColors',
    value: function initProductColors() {
      var _this = this;

      this.productColors = this.el.querySelector('[data-product-colors]');

      if (this.productColors) {
        this.productColorScroller = this.productColors.querySelector('.product-colors');
        this.ev.register(this.el, 'mouseenter', function () {
          _this.el.style.height = _this.el.offsetHeight + 'px';
          _this.el.classList.add('product-item-hover');
        });
        this.ev.register(this.el, 'mouseleave', function () {
          _this.el.style.height = 'auto';
          _this.el.classList.remove('product-item-hover');
        });
        this.ev.register(this.el.querySelector('.product-scroll-trigger'), 'click', function (ev) {
          ev.preventDefault();
          var offset = _this.productColorScroller.clientWidth * (ev.currentTarget.classList.contains('product-scroll-right') ? 1 : -1);
          _this.productColorScroller.scrollBy({ top: 0, left: offset, behavior: 'smooth' });
        });
        this.productColorScroller.querySelectorAll('.product-color').forEach(function (color) {
          var colorImg = new Image();
          _this.ev.register(color, 'mouseenter', function (ev) {
            var colorText = ev.currentTarget.dataset.color,
                colorImage = ev.currentTarget.dataset.productImage,
                titleText = ev.currentTarget.dataset.title,
                priceText = ev.currentTarget.dataset.price,
                priceMaxText = ev.currentTarget.dataset.priceMax,
                comparePriceText = ev.currentTarget.dataset.comparePrice;
            _this.colorLabel ? _this.colorLabel.innerText = colorText : null;
            _this.titleLabel ? _this.titleLabel.innerText = titleText : null;
            _this.priceLabel ? _this.priceLabel.innerText = priceText : null;
            _this.priceMaxLabel ? _this.priceMaxLabel.innerText = priceMaxText || '' : null;
            _this.priceCompareLabel ? _this.priceCompareLabel.innerText = comparePriceText || '' : null;
            colorImg.src = colorImage;
            colorImg.classList.add('color-image');
            _this.productImage.appendChild(colorImg);
          });
          _this.ev.register(color, 'mouseleave', function (ev) {
            var colorText = _this.el.querySelector('.product-color.current-color').dataset.color,
                titleText = _this.el.querySelector('.product-color.current-color').dataset.title,
                priceText = _this.el.querySelector('.product-color.current-color').dataset.price,
                priceMaxText = _this.el.querySelector('.product-color.current-color').dataset.priceMax,
                comparePriceText = _this.el.querySelector('.product-color.current-color').dataset.comparePrice;
            var removeImg = _this.ev.register(colorImg, 'animationend', function () {
              colorImg.remove();
              colorImg.classList.remove('fade-out');
              _this.ev.unregister(removeImg);
            });
            setTimeout(function () {
              colorImg.classList.add('fade-out');
            }, 150);
            _this.colorLabel ? _this.colorLabel.innerText = colorText : null;
            _this.titleLabel ? _this.titleLabel.innerText = titleText : null;
            _this.priceLabel ? _this.priceLabel.innerText = priceText : null;
            _this.priceMaxLabel ? _this.priceMaxLabel.innerText = priceMaxText : null;
            _this.priceCompareLabel ? _this.priceCompareLabel.innerText = comparePriceText : null;
          });
        });
      }
    }
  }, {
    key: 'unload',
    value: function unload() {
      this.ev.unregisterAll();
    }
  }]);
  return ProductItem;
}();

exports.default = ProductItem;